import { useContext } from 'react';
import { RolesContext } from './roles-context';
export var useRoles = function () { return useContext(RolesContext); };
